// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"460": "618603b5eb4f48c4","9032": "e5afb1b9322338a6",}[chunkId] + ".bundle.css"
}